import { render } from "./PortfolioPerformance.vue?vue&type=template&id=72abbdfa&scoped=true"
import script from "./PortfolioPerformance.vue?vue&type=script&lang=js"
export * from "./PortfolioPerformance.vue?vue&type=script&lang=js"

import "./PortfolioPerformance.vue?vue&type=style&index=0&id=72abbdfa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72abbdfa"]])

export default __exports__